const computePaymentFee = (amount) => {
  return amount >= 30000 ? 0 : 250;
};

module.exports = {
  computePaymentFee,
};
